import watchSetClient from './setClient';
import watchUpdateClient from './updateClient';
import watchSyncAction from './syncAction';

const watchEditClient = [watchSetClient, watchUpdateClient, watchSyncAction];

export default watchEditClient;
